import { useState as s, useEffect as g } from "react";
import "../../i18n/context/KnockI18nProvider.mjs";
import { useTranslations as A } from "../../i18n/hooks/useTranslations.mjs";
const C = (o) => {
  const e = o.substring(0, 1).toUpperCase(), c = o.substring(1);
  return e == null ? void 0 : e.concat(c).replace("_", " ");
};
function y(o, e, c) {
  const {
    t: a
  } = A(), [r, n] = s("connecting"), [p, i] = s(null), [b, m] = s(null);
  return g(() => {
    (async () => {
      var u, l, f, k, S, d, h;
      if (r === "connecting")
        try {
          const t = await o.slack.authCheck({
            tenant: c,
            knockChannelId: e
          });
          if ((u = t.connection) != null && u.ok)
            return n("connected");
          if (!((l = t.connection) != null && l.ok) || t.code === "ERR_BAD_REQUEST" && ((k = (f = t.response) == null ? void 0 : f.data) == null ? void 0 : k.message) === a("slackAccessTokenNotSet"))
            return n("disconnected");
          if (!((S = t.connection) != null && S.ok) && ((d = t.connection) != null && d.error)) {
            const E = C((h = t.connection) == null ? void 0 : h.error);
            i(E), n("error");
            return;
          }
          n("error");
        } catch {
          n("error");
        }
    })();
  }, [r, c, e, o.slack, a]), {
    connectionStatus: r,
    setConnectionStatus: n,
    errorLabel: p,
    setErrorLabel: i,
    actionLabel: b,
    setActionLabel: m
  };
}
export {
  y as default
};
//# sourceMappingURL=useSlackConnectionStatus.mjs.map
